'use-client';
import YouTubeSubscribeButton from '../../YouTubeSubscribeButton';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(YouTubeSubscribeButton, {
  componentConsentPolicy: { advertising: true },
});
